<template>
  <div class="select-category">
    <!-- ラベル -->
    <div class="select-category__label" ref="select_label">
      <!-- label -->
      <p v-if="isLabelDisplay" class="select-category__text">{{ labelText }}</p>
      <!-- button -->
      <div class="select-category__wrap --button">
        <button
          :title="currentLabel"
          class="select-category__button --pseudo-input"
          :class="{
            'is-focused': isModalActive,
            'is-inputed': currentSelectLargeLabel !== '',
            'is-error': isError,
            'is-deep-color': isDeepPlaceHoldColor,
          }"
          @click="swtichModal(true)"
        >
          {{ getLabel() }}
        </button>
        <!-- arrow icon -->
        <IconArrow :isFocus="isModalActive" />
      </div>
    </div>

    <!-- 一覧 -->
    <div v-if="isModalActive" class="select-category__wrap --modal">
      <div
        class="select-category__modal"
        :class="{
          'is-hidden-label': !isLabelDisplay,
          'is-fixed-width': isFixedWidth,
        }"
      >
        <div class="select-category__heading">
          <span>{{ labelText }}を選択してください</span>
          <button
            class="select-category__button --close"
            @click="setCategoryData"
          ></button>
        </div>

        <ul class="select-category__list --large" ref="list_large">
          <li
            v-for="large in getList"
            :key="`large-list-${large.id}`"
            class="select-category__item --large"
            :class="setButtonState(large.id, currentSelectLargeId)"
          >
            <button
              ref="button_medium"
              class="select-category__button --large"
              :class="setButtonState(large.id, currentSelectLargeId)"
              @click="setCurrentSelectLarge(large)"
            >
              {{ large.label }}
            </button>
            <div
              class="select-category__wrap --list"
              :class="{ 'is-active': large.id === currentSelectLargeId }"
            >
              <ul class="select-category__list --medium">
                <li
                  v-for="medium in large.target"
                  :key="`medium-list-${medium.id}`"
                  class="select-category__item --medium"
                  :class="{
                    'has-small-category': medium.target,
                    'is-active': currentSelectMediumId.includes(medium.id),
                  }"
                >
                  <button
                    class="select-category__button --medium"
                    :class="setButtonState(medium.id, currentSelectMediumId, 'medium')"
                    @click="setCurrentSelectMedium(medium)"
                  >
                    {{ medium.label }}
                  </button>
                  <div
                    class="select-category__wrap --list --small"
                    :class="{
                      'is-active': currentSelectMediumId.includes(medium.id),
                    }"
                  >
                    <ul class="select-category__list --small">
                      <li
                        v-for="small in medium.target"
                        :key="`small-list-${small.id}`"
                        class="select-category__item --small"
                      >
                        <button
                          class="select-category__button --small"
                          :class="
                            setButtonState(
                              small.id,
                              currentSelectSmallId,
                              'small',
                            )
                          "
                          @click="setCurrentSelectSmall(small)"
                        >
                          {{ small.label }}
                        </button>
                      </li>
                    </ul>
                  </div>
                </li>
              </ul>
            </div>
          </li>
        </ul>

        <div class="select-category__buttons">
          <button
            class="select-category__button --reset"
            @click="resetCurrentSelect('all')"
          >
            リセット
          </button>
          <button
            class="select-category__button --dicision"
            @click="setCategoryData"
          >
            決定
          </button>
        </div>
      </div>
    </div>
    <div
      v-if="isModalActive"
      class="select-category__background"
      @click="setCategoryData"
    ></div>
  </div>
</template>

<script>
import CategoryList from '../categoryList.json'
import PrefecturesList from '../prefecturesList.json'
import IconArrow from '@/components/elements/AppIconArrow/'

export default {
  name: 'SelectModal',
  components: {
    IconArrow
  },
  data() {
    return {
      isModalActive: false,          // 選択画面が表示されているか

      currentSelectRegionId: '',     // modalTypeがareaの時、地方情報を代入（region-1, region-2...）

      currentSelectLargeId: '',      // 現在選択されている大カテゴリ (hokkaido, aomori...)
      currentSelectMediumId: '',     // 現在選択されている中カテゴリ (sapporo, jozankei...)
      currentSelectSmallId: '',      // 現在選択されている小カテゴリ (上からA, B, C...)

      currentSelectLargeLabel: '',   // 現在選択されている大カテゴリの文字列
      currentSelectMediumLabel: '',  // 現在選択されている中カテゴリの文字列
      currentSelectSmallLabel: '',   // 現在選択されている小カテゴリの文字列

      currentQueryLarge: {},         // 現在クエリに設定されている大カテゴリ情報
      currentQueryMedium: {},        // 現在クエリに設定されている中カテゴリ情報
      currentQuerySmall: {},         // 現在クエリに設定されている小カテゴリ情報

      lastClickedLargeRefIndex: -1,  // 最後にクリックされた大カテゴリのref_index
      lastClickedMediumRefIndex: -1, // 最後にクリックされた中カテゴリのref_index
      
      currentSelectMediumList: [],   // 中カテゴリの複数選択が許可されている際に、選択された小カテゴリ情報を格納
      currentSelectSmallList: [],    // 小カテゴリの複数選択が許可されている際に、選択された小カテゴリ情報を格納

      buttonHeight: 48,                  // モーダル内のボタンの高さ。以下のスクロール量計算に使用
      scrollPoint: 0,                    // クリックされたボタンをモーダル内のトップにスクロールさせるためのスクロール量

      currentLabel: '',       // 現在選択されている条件から生成されたカテゴリの文字列

      windowWidth: 0                     // resizeイベントで代入されるウィンドウ幅
    }
  },
  props: {
    modalType: {
      type: String,
      required: true,
      validator: (value) => {
        return ['category', 'area'].includes(value)
      }
    },
    // エラー状態か
    isError: {
      type: Boolean,
      required: false,
      default: false
    },
    // プレースホールドに表示したいテキスト
    placeHoldText: {
      type: String,
      required: false,
      default: ''
    },
    // プレースホールドの色を標準で濃くするか
    isDeepPlaceHoldColor: {
      type: Boolean,
      required: false,
      default: false
    },
    // input左側、モーダル内ヘッダーに表示するラベル
    labelText: {
      type: String,
      required: false,
      default: ''
    },
    // input左側に表示されるラベルの表示状態
    isLabelDisplay: {
      type: Boolean,
      required: false,
      default: true
    },
    // モーダル幅を固定で表示したい
    isFixedWidth: {
      type: Boolean,
      required: false,
      default: false
    },
    // smallの複数選択の許可
    isMultipleSelect: {
      type: Boolean,
      required: false,
      default: false
    },
    // ラベルがクリックされたら任意の位置までスクロールさせる、そのスクロール量
    scrollPointToLabel: {
      type: Number,
      required: false,
      default: 0
    }
  },
  computed: {
    /**
     * リストを返却
     */
    getList() {
      if (this.modalType === 'category') {
        return CategoryList
      }
      return PrefecturesList
    },
  },
  watch: {
    /**
     * モーダルの開閉状態に応じて処理
     */
    isModalActive() {
      if (this.isModalActive) {
        this.scrollListInModal()
        return
      }
      this.scrollPoint = 0
    },
  },
  created() {
    // 複数選択モードの場合は中・小カテゴリが複数選択対象となるため、その前処理
    if (
      this.isMultipleSelect &&
      this.currentSelectSmallId === '' &&
      this.currentSelectSmallLabel === '' &&
      this.currentSelectMediumId &&
      this.currentSelectMediumLabel
    ) {
      this.currentSelectSmallId = []
      this.currentSelectSmallLabel = []
      this.currentSelectMediumId = []
      this.currentSelectMediumLabel = []
    }
    // escapeキー押下でモーダルを閉じる
    window.addEventListener('keydown', event => {
      if (event.key === 'Escape') {
        this.isModalActive = false
      }
    })
    // クエリパラメータから状態を反映
    this.setDataFromQuery()
  },
  mounted() {
    this.windowWidth = window.innerWidth
    window.addEventListener('resize', () => {
      this.windowWidth = window.innerWidth
    })
    this.setCategoryData()
    this.setScrollPoint()
  },
  methods: {
    /**
     * created時、クエリパラメータから初期値を設定
     */
    setDataFromQuery() {
      const query = this.$route.query
      const [large, middle, small] = [
        this.modalType === 'area' ? query.areaMidClassCd : query.catLrgClassCd,
        this.modalType === 'area' ? query.areaSmlClassCd : query.catMidClassCd,
        this.modalType === 'area' ? query.areaDtlClassCd : query.catSmlClassCd,
      ]

      if (this.modalType === 'area') {
        // this.currentSelectLargeId = query.areaLrgClassCd
        this.currentSelectRegionId = query.areaLrgClassCd
      }

      if (large) {
        this.currentQueryLarge = this.getList.filter(d => d.id === large)[0]
        this.currentSelectLargeId = large
        this.currentSelectLargeLabel = this.currentQueryLarge.label
      }

      // TODO: ここ直す
      if (middle) {
        if (middle.includes(',')) {
          const middleList = middle.split(',')
          this.currentQueryMedium = []
          middleList.forEach((d, i) => {
            this.currentQueryMedium[i] = this.currentQueryLarge.target.filter(e => e.id === d)[0]
          })
          this.currentSelectMediumLabel = this.currentQueryMedium.map(d => d.label).join('、')
        } else {
          this.currentQueryMedium = this.currentQueryLarge.target.filter(d => d.id === middle)[0]
          this.currentSelectMediumLabel = this.currentQueryMedium.label
        }
        this.currentSelectMediumId = middle
      }

      if (small) {
        if (small.includes(',')) {
          const smallList = small.split(',')
          this.currentQuerySmall = []
          const _currentQueryMedium = [this.currentQueryMedium].flat()
          smallList.forEach((d, i) => {
            this.currentQuerySmall[i] = _currentQueryMedium[0].target.filter(e => e.id === d)[0]
          })
          this.currentSelectSmallLabel = this.currentQuerySmall.map(d => d.label).join('、')
        } else {
          if (this.currentQueryMedium.length > 1) {
            this.currentQuerySmall = this.currentQueryMedium[0].target.filter(d => d.id === small)[0]
          } else {
            this.currentQuerySmall = this.currentQueryMedium.target.filter(d => d.id === small)[0]
          }
          this.currentSelectSmallLabel = this.currentQuerySmall.label
        }
        this.currentSelectSmallId = small
      }
      
    },
    /**
     * 選択モーダルの表示切替
     * @param {boolean} bool 
     */
    swtichModal(bool) {
      this.isModalActive = bool
      if (this.scrollPointToLabel > 0) {
        this.onScrollLabel()
      }
    },
    /**
     * inputがクリックされ、モーダルが開いた際に
     * 選択しやすいようにページをスクロールさせる
     */
    onScrollLabel() {
      const isMobileSize = this.windowWidth < 640
      if (isMobileSize) return

      if (this.isModalActive) {
        const label = this.$refs.select_label
        const top = label.getBoundingClientRect().top
        const currentScroll = window.scrollY
        const margin = this.scrollPointToLabel // ページ上部からどれだけ離して表示させるかの数値

        window.scrollTo({
          top: top + currentScroll - margin,
          behavior: "smooth",
        })
      }
    },
    /**
     * v-forから取得したidと、現在設定されているidを比較して
     * 適切なclassを返却する
     */
    setButtonState(id, currentId, type) {
      if (this.isMultipleSelect && (type === 'small' || type === 'medium')) {
        return currentId.includes(id)
          ? 'is-active'
          : ''
      }

      return id === currentId
        ? 'is-active'
        : ''
    },
    /**
     * クリックされているエリア情報から、モーダル内でスクロールする量を計算する
     */
    setScrollPoint() {
      // モーダル内でリセットが押され、何も選択されていない場合はスクロール量を0に戻して終了
      const [isUnsetLargeId, isUnsetMediumId] = [
        this.currentSelectLargeId === '',
        this.currentSelectMediumId === '',
      ]

      if (isUnsetLargeId && isUnsetMediumId) {
        this.scrollPoint = 0
        return
      }

      // リロードして、最後にクリックされた情報がリセットされた場合は
      // クエリパラメータから現在選択されている情報を取得し、スクロール量を算出する
      const [isUnsetLargeIndex, isUnsetMediumIndex] = [
        this.lastClickedLargeRefIndex === -1,
        this.lastClickedMediumRefIndex === -1,
      ]
      
      if (isUnsetLargeIndex && isUnsetMediumIndex) {
        this.lastClickedLargeRefIndex = this.currentQueryLarge.ref_index
        this.lastClickedMediumRefIndex = this.currentQueryMedium.ref_index + 1
      }

      const [large, medium] = [
        this.lastClickedLargeRefIndex > -1 ? this.lastClickedLargeRefIndex : 0,
        this.lastClickedMediumRefIndex > -1 ? this.lastClickedMediumRefIndex : 0,
      ]
      
      this.scrollPoint = (large + medium) * this.buttonHeight
    },
    /**
     * クリックされたらモーダル内でトップへスクロールさせる
     */
    scrollListInModal() {
      this.setScrollPoint()

      setTimeout(() => {
        this.largeList = this.$refs.list_large
        this.largeList.scrollTo({
          top: this.scrollPoint,
          behavior: "smooth"
        })
      }, 50)
    },
    /**
     * large情報を設定する
     * @param {object} large 
     */
    setCurrentSelectLarge(large) {
      
      this.resetCurrentSelect('large')
      if (this.currentSelectLargeId === large.id) {
        this.currentSelectLargeId = ''
        this.currentSelectLargeLabel = ''
        this.lastClickedLargeRefIndex = -1
        if (this.modalType === 'area') {
          this.currentSelectRegionId = ''
        }
        this.scrollListInModal()
        return
      }


      if (this.modalType === 'area') {
        this.currentSelectRegionId = large.region
      }
      this.currentSelectLargeId = large.id
      this.currentSelectLargeLabel = large.label
      this.lastClickedLargeRefIndex = large.ref_index

      this.scrollListInModal()
    },
    /**
     * medium情報を設定する
     * @param {object} medium
     */
    setCurrentSelectMedium(medium) {
      if (this.currentSelectMediumId === medium.id && !this.isMultipleSelect) {
        this.resetCurrentSelect('medium')
        this.currentSelectMediumId = ''
        this.currentSelectMediumLabel = ''
        this.lastClickedMediumRefIndex = -1
        this.scrollListInModal()
        return
      }

      // selectsmallからコピペ
      // エリアが複数選択の場合
      if (this.isMultipleSelect) {
        if (this.currentSelectMediumList.some(d => d.id === medium.id)) {
          this.currentSelectMediumList = this.currentSelectMediumList.filter(d => d.id !== medium.id)
        } else {
          this.currentSelectMediumList.push(medium)
        }
        this.currentSelectMediumList.sort((a, b) => a.ref_index > b.ref_index ? 1 : -1)
        this.currentSelectMediumId = this.currentSelectMediumList.map(d => d.id)
        this.currentSelectMediumLabel = this.currentSelectMediumList.map(d => d.label)
        this.lastClickedMediumRefIndex = medium.ref_index + 1
        
        const checkedMedium = this.currentSelectMediumList.map(d => d.id).includes(medium.id)
        if (checkedMedium && medium?.target) {
          this.currentSelectSmallId = []
          this.currentSelectSmallLabel = []
          this.currentSelectSmallList = []
        }
      }
      // エリアが単一選択の場合
      else {
        this.currentSelectMediumId = medium.id
        this.currentSelectMediumLabel = medium.label
        this.lastClickedMediumRefIndex = medium.ref_index + 1
        this.scrollListInModal()
      }

      // this.currentSelectMediumId = medium.id
      // this.currentSelectMediumLabel = medium.label

    },
    /**
     * small情報を設定する
     * @param {object} small
     */
    setCurrentSelectSmall(small) {
      if (this.currentSelectSmallId === small.id && !this.isMultipleSelect) {
        this.currentSelectSmallId = ''
        this.currentSelectSmallLabel = ''
        return
      }

      // エリアが複数選択の場合
      if (this.isMultipleSelect) {
        if (this.currentSelectSmallList.some(d => d.id === small.id)) {
          this.currentSelectSmallList = this.currentSelectSmallList.filter(d => d.id !== small.id)
        } else {
          this.currentSelectSmallList.push(small)
        }
        this.currentSelectSmallList.sort((a, b) => a.id > b.id ? 1 : -1)
        this.currentSelectSmallId = this.currentSelectSmallList.map(d => d.id)
        this.currentSelectSmallLabel = this.currentSelectSmallList.map(d => d.label)
      }
      // エリアが単一選択の場合
      else {
        this.currentSelectSmallId = small.id
        this.currentSelectSmallLabel = small.label
      }
    },
    /**
     * キャンセルが押下されたら選択された各情報をリセットする
     * @param {type} string
     */
    resetCurrentSelect(type) {
      this.currentSelectSmallId = ''
      this.currentSelectSmallLabel = ''
      this.currentSelectSmallList = []
      if (type === 'medium') return

      this.currentSelectMediumId = ''
      this.currentSelectMediumLabel = ''
      this.lastClickedMediumRefIndex = -1
      this.currentSelectMediumList = []
      if (type === 'large') return

      this.currentSelectLargeId = ''
      this.currentSelectLargeLabel = ''
      this.lastClickedLargeRefIndex = -1
      if (this.modalType === 'area') {
        this.currentSelectRegionId = ''
      }
      this.scrollListInModal()
    },
    /**
     * カテゴリの文字列を返却
     * 設定されていない場合は選択を促す文字列を返却
     */
    getLabel() {
      const [large, medium, small] = [
        String(this.currentSelectLargeLabel),
        String(this.currentSelectMediumLabel),
        String(this.currentSelectSmallLabel)
      ]

      const formatText = str => (str !== '' ? ` / ${str}` : '')

      if (this.isMultipleSelect && this.currentSelectMediumList.length > 1) {
        this.currentLabel = large === ''
        ? ''
        : large + formatText(medium)
      } else {
        this.currentLabel = large === ''
        ? ''
        : large + formatText(medium) + formatText(small)
      }

      return this.currentLabel === ''
        ? this.placeHoldText
        : this.currentLabel
    },
    /**
     * 現在の設定をemitし、ラベルを生成する
     */
    setCategoryData() {
      const smallId = this.isMultipleSelect && this.currentSelectSmallList.length > 0
        ? this.currentSelectSmallId.join(',')
        : this.currentSelectSmallId

      const smallLabel = this.isMultipleSelect && this.currentSelectSmallList.length > 0
        ? this.currentSelectSmallLabel.join('、')
        : this.currentSelectSmallLabel

      const mediumId = this.isMultipleSelect && this.currentSelectMediumList > 0
        ? this.currentSelectMediumId.join(',')
        : this.currentSelectMediumId

      const mediumLabel = this.isMultipleSelect && this.currentSelectMediumList.length > 0
        ? this.currentSelectMediumLabel.join('、')
        : this.currentSelectMediumLabel

      const parameters = {
        large_id: this.currentSelectLargeId,
        large_label: this.currentSelectLargeLabel,
        medium_id: mediumId,
        medium_label: mediumLabel,
        small_id: smallId,
        small_label: smallLabel,
        category_label: this.currentLabel
      }

      // modalTypeが都道府県の場合、region情報も含める
      // 都道府県・市区町村・エリアが「""」の場合、undefinedとする
      // TODO: 今後BFF側の仕様が判明次第修正
      if (this.modalType === 'area') {
        parameters.region_id = this.currentSelectRegionId
        parameters.large_id = this.currentSelectLargeId === '' ? undefined : this.currentSelectLargeId
        parameters.medium_id = this.currentSelectMediumId === '' ? undefined : this.currentSelectMediumId
        parameters.small_id = this.currentSelectSmallId === '' ? undefined : this.currentSelectSmallId
      }

      this.$emit('inputed', parameters)
      this.swtichModal(false)
    }
  }
}
</script>

<style src="./style.scss" lang="scss" scoped></style>
